export const flagKey = {
  wineClubFlatRate: 'wine-club-flat-rate',
  shippingLabelZpl: 'shipping-label-zpl',
  payConnect: 'pay-connect',
  mfAdminOrder: 'mf-admin-order',
  reportModule: 'report-module',
  payEngine: 'pay-engine',
  giftCard: 'gift-card',
  excludeItemsDiscount: 'exclude-items-discount',
  glsShipment: 'gls-shipment',
  summaryEmails: 'summary-emails',
  quickbookTip: 'quickbook-tip',
  customerPaymentUpdateSubMultiple: 'customer-multi-subscription-payment',
  deleteCustomer: 'delete-customer',
  orderSubtype: 'order-subtype',
  exportReports: 'export-reports',
}
